import { createSlice } from '@reduxjs/toolkit';

import {
  getLessonById,
  updateLessonById,
  updateLessonStatusById,
  removeLessonById,
} from './actions';

const lessonSlice = createSlice({
  name: 'currentLesson',
  initialState: null,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getLessonById.fulfilled, (state: any, action: any) => {
      return {
        ...action.payload,
      };
    });

    builder.addCase(
      updateLessonStatusById.fulfilled,
      (state: any, action: any) => {
        return {
          ...state,
          ...action.payload,
        };
      },
    );

    builder.addCase(updateLessonById.fulfilled, (state: any, action: any) => {
      return {
        ...state,
        ...action.payload,
      };
    });

    builder.addCase(removeLessonById.fulfilled, (state: any, action: any) => {
      return action.payload;
    });
  },
});

export default lessonSlice.reducer;
